import React, { useState } from "react";
import StepScreenshot from "./stepScreenshot";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import ScreenshotsSlideshow from "./screenshotsSlideshow";
import { GlobalStore } from "../../stores/global";

const SubscribeForm = () => {
  const mailchimp = GlobalStore.useState(c => c.mailchimpLinks);
  if (!mailchimp) return null;
  const { mailchimpAudienceUrl } = mailchimp;

  return (
    <MailchimpSubscribe
      url={mailchimpAudienceUrl}
      render={({ subscribe, status, message }) => (
        <form
          onSubmit={e => {
            e.preventDefault();
            subscribe({ EMAIL: e.target.email.value });
            e.target.email.value = "";
          }}
          className="mailchimpCodeForm">
          <div className="emailForm">
            <input type="email" required name="email" placeholder="Enter Email Address" />
            <button type="submit" aria-label="send email code">
              <img
                alt="send email code"
                src="https://public.speedoc.com/design/images/speedoc.com/aside/rightArrow.svg"
              />
            </button>
          </div>
          {status === "success" && message.length > 0 ? (
            `${message}`
          ) : status === "error" ? (
            <p>
              This email is already in use. If you feel this is an error, please contact{" "}
              <a alt="anchor to contact" href="mailto:support@speedoc.com">
                support@speedoc.com
              </a>
              .
            </p>
          ) : (
            ""
          )}
        </form>
      )}
    />
  );
};

const ExistingUsers = ({ content = {} }) => {
  const { steps = [] } = content;
  const [selectedLine, setSelectedLine] = useState(1);

  return (
    <>
      <div className="existingUsers">
        <div className="left">
          <div className="content bottom">
            <ul>
              {steps.map(({ content: stepDescription }, i) => (
                <li key={i}>
                  <StepScreenshot
                    index={i + 1}
                    currentIndex={selectedLine}
                    changeIndex={setSelectedLine}
                    text={stepDescription}
                    component={i === 0 && <SubscribeForm />}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="right">
          <ScreenshotsSlideshow
            images={steps.map(({ image }) => image)}
            currentIndex={selectedLine - 1}
            keyName="existingUsers"
          />
        </div>
      </div>
    </>
  );
};

export default ExistingUsers;
